import { useMemo } from 'react';
import type { EstimateItem } from '../types/estimate.types';

export function useEstimatePricing(
  items: EstimateItem[],
  overheadPercent = 0,
  profitPercent = 0,
  taxPercent = 10
) {
  return useMemo(() => {
    const materialCost = items.reduce((sum, item) => sum + item.material_cost, 0);
    const laborCost = items.reduce((sum, item) => sum + item.labor_cost, 0);
    const equipmentCost = items.reduce((sum, item) => sum + item.equipment_cost, 0);
    const subcontractCost = items.reduce((sum, item) => sum + item.subcontract_cost, 0);
    const subtotal = materialCost + laborCost + equipmentCost + subcontractCost;
    
    const overheadAmount = subtotal * (overheadPercent / 100);
    const profitAmount = (subtotal + overheadAmount) * (profitPercent / 100);
    const subtotalBeforeTax = subtotal + overheadAmount + profitAmount;
    const taxAmount = subtotalBeforeTax * (taxPercent / 100);
    const totalAmount = subtotalBeforeTax + taxAmount;

    const warningItems = items.filter((item) => item.quantity <= 0 || item.unit_price <= 0);

    return {
      materialCost,
      laborCost,
      equipmentCost,
      subcontractCost,
      subtotal,
      overheadAmount,
      profitAmount,
      taxAmount,
      totalAmount,
      warningItems,
      warningCount: warningItems.length,
      isValidForReview: items.length > 0 && warningItems.length === 0 && subtotal > 0,
    };
  }, [items, overheadPercent, profitPercent, taxPercent]);
}
